import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/website.svg';

export const IconWebsite = createIconComponent(Icon);
